export class MediaPlanOptionVO {
    type: MediaPlanType;
    cpm: number;
    impressions: number
    estimatedSpots: number;
    dayPartConstraintId?: string;
    buyDemoConstraintId?: number;

    // constructor(type : string) {
    //     this.type = MediaPlanType[type];
    // }
}

export enum MediaPlanType {
    Standard = 'Standard',
    Plus = 'Plus',
    Premium = 'Premium'
}
